import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapFields } from "@joandvgv/vuex-map-fields";
import { mapGetters, mapState } from "vuex";
import { IS_USAGE_RESTRICTED } from "@Broker/@Modules/account-plan/store/account-plan-getters";
import PlanTooltip from "@Broker/@Modules/account-plan/components/account-plan-usage/plan-tooltip.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AutomationShareSelection",
  components: {
    PlanTooltip
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapFields("AutomationStore", ["currentAutomation.shared", "shareSelection"])), mapState("AccountPlanStore", ["currentPagePlan"])), mapGetters("AccountPlanStore", [IS_USAGE_RESTRICTED])), {}, {
    isUsageRestricted() {
      return this.IS_USAGE_RESTRICTED(this.currentPagePlan);
    }
  }),
  methods: {
    selectShare(value) {
      this.shared = value;
      this.shareSelection = true;
    }
  }
});